import React from 'react'
import { TranslationProvider } from '../../shared/TranslationProvider'
import translations from '../locales.json'
import { CoachChatProvider } from './CoachChatContext'
import CoachChatInner from './CoachChatInner'

const CoachChat = (props) => {
  // Check if required props are present
  if (!props.socketUrl || !props.username || !props.chatRoom) {
    console.error('CoachChat - Missing required props:', {
      socketUrl: props.socketUrl,
      username: props.username,
      chatRoom: props.chatRoom,
    })
    return (
      <div className="coach-chat-error">
        <h3>Chat Configuration Error</h3>
        <p>
          Missing required configuration: {!props.socketUrl ? 'socketUrl' : ''}{' '}
          {!props.username ? 'username' : ''}{' '}
          {!props.chatRoom ? 'chatRoom' : ''}
        </p>
        <pre>{JSON.stringify(props, null, 2)}</pre>
      </div>
    )
  }

  return (
    <TranslationProvider
      locale={props.current_user?.locale || 'en'}
      translations={translations}
      scope="javascript.components"
    >
      <CoachChatProvider {...props}>
        <CoachChatInner />
      </CoachChatProvider>
    </TranslationProvider>
  )
}

export default CoachChat
